import { Component, OnInit, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { PublicService } from 'src/app/services/public/public.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document,
  private renderer: Renderer2, private router:Router,public elementRef: ElementRef,
  private  publicService:PublicService,public globalHelper :GlobalHelper) {    

  }
  SearchModel = {
    IsActive: true,
  }
  images:any;
  GetSchoolSlider  () {
    
    this.publicService.GetSchoolSlider().subscribe( (data) =>{
      this.images = data.SliderList;
     
      this.globalHelper.CheckActionStatus(data);
      
    });
};
  ngOnInit() {
  
    this.GetSchoolSlider();
  }

}
